import { Get, postJSON } from "../utils/http.js"

// 获取聚合首页数据
export function getEcomHomeData(params, config = {}) {
  return Get("/api/item/ecomPage", params, config)
}

// 获取首页数据
export function getHomeData(params, config = {}) {
  return Get("/api/item/indexTemplateData", params, config)
}

// 获取Dshop数据
export function getDshopData(params, config = {}) {
  return Get("/api/item/dshop", params, config)
}

// 获取分类页列表
export function getCategoryList(params, config = {}) {
  return postJSON("/api/item/templateData", params, config)
}

// 获取商品详情spu
export function getProductDetailSpu(params, config = {}) {
  return Get("/api/item/product/getSpuDetail", params, config)
}

// 获取商品详情
export function getProductDetail(params, config = {}) {
  return Get("/api/item/product/getDetail", params, config)
}

// 获取相似商品
export function getSimilarList(params, config = {}) {
  return Get("/api/item/product/getSimilarList", params, config)
}

// Banner Home预览
export function getBannerHomePreview(params, config = {}) {
  return Get("/api/item/preview", params, config)
}
